export class SocialNumber {
  static isValid(value: string): boolean {
    return value.replace(/[.-]/g, "").length === 11;
  }

  constructor(private value: string) {}

  getSocialNumber(): string {
    return this.value;
  }
}
